// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

// TODO: Replace the following with your app's Firebase project configuration
// You can find this in the Firebase Console -> Project Settings -> General -> Your Apps
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAx-MwHsb9b_-f1CoFCAq5tfjtIz9Qxb4k",
  authDomain: "kado-web-17113.firebaseapp.com",
  projectId: "kado-web-17113",
  storageBucket: "kado-web-17113.firebasestorage.app",
  messagingSenderId: "1041430451984",
  appId: "1:1041430451984:web:cd3dc16010ecec306bb795",
  measurementId: "G-7T5WTGR7NS",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { app, analytics };
